import {
    CHARTS_WHICH_NEED_ADJUSTMENT_FOR_RELEVANCE, EMOTION_OR_SENTIMENT_BAR_CHART_IDS,
    EMOTION_OR_SENTIMENT_MENTIONS_CHARTS_IDS, EMOTION_OR_THREE_CLASS_SENTIMENT_PIE_CHARTS_IDS,
    EMOTION_OR_SENTIMENT_TREND_CHART_IDS, FIVE_CLASS_SENTIMENT_PIE_CHARTS_IDS, MENTIONS_LABEL, PARSE_INT_RADIX,
    UPDATE_SELECTED_CHART_DETAILS_AFTER_COMMENT_OR_TWEET_RELEVANCE_UPDATES, EMOTION_PIE_CHART_ID, TOTAL,
    AVAILABLE_SOURCES_PIE_CHART_IDS, EMOTION_OR_SENTIMENT_PERCENTAGE_TREND_CHART_IDS, MONTH_UNIT, HOUR_UNIT,
    DEFAULT_HOUR_FOR_DAILY_AND_MONTHLY_TREND_CHARTS, DEFAULT_DAY_FOR_MONTHLY_TREND_CHARTS
} from './constants';
import moment from 'moment';
import { NEGATIVE, NO_SPECIFIC_EMOTION, POSITIVE, VERY_NEGATIVE, VERY_POSITIVE } from '../../../home/redux/constants';
import { isSubTopicClustersChartWithData } from './updateChartForRelevanceUpdatesOfPostService';
  
export function updateChartForRelevanceUpdatesOfCommentOrTweet(chartId,commentOrTweetAfterRelevanceUpdates,trendChartTimeUnit) {
    return dispatch => {
        dispatch({
            type: UPDATE_SELECTED_CHART_DETAILS_AFTER_COMMENT_OR_TWEET_RELEVANCE_UPDATES,
            data: {
                chartId: chartId,
                commentOrTweetAfterRelevanceUpdates: commentOrTweetAfterRelevanceUpdates,
                trendChartTimeUnit: trendChartTimeUnit
            }
        });
    };
  }

export function reducer(state, action) {
    if (action.type !== UPDATE_SELECTED_CHART_DETAILS_AFTER_COMMENT_OR_TWEET_RELEVANCE_UPDATES) {
        return state;
    }
    if (!state) {
        return state;
    }
    const { 
        chartId, 
        commentOrTweetAfterRelevanceUpdates,
        trendChartTimeUnit
    } = action.data;
    if ((!state.hasOwnProperty(chartId)) || (!CHARTS_WHICH_NEED_ADJUSTMENT_FOR_RELEVANCE.includes(chartId))) {
        return state;
    }
    const relevance = commentOrTweetAfterRelevanceUpdates.relevance;
    const emotionCategory   = commentOrTweetAfterRelevanceUpdates.emotion.category;
    const sentimentCategory = commentOrTweetAfterRelevanceUpdates.sentiment.category;
    const threeClassSentimentCategory = getThreeClassSentimentCategory(sentimentCategory);
  
    if (EMOTION_OR_SENTIMENT_MENTIONS_CHARTS_IDS.includes(chartId) && state[chartId].length > 0) {
        let newState = updateEmotionOrSentimentMentionsCharts(
            state,
            chartId,
            relevance,
            emotionCategory,
            threeClassSentimentCategory
        );
        return newState;
    }

    else if (isTrendOrPercentageTrendChart(chartId) && state[chartId].length > 0) {
        let newState = updateEmotionOrSentimentTrendCharts(
            state,
            commentOrTweetAfterRelevanceUpdates,
            chartId,
            relevance,
            emotionCategory,
            threeClassSentimentCategory,
            trendChartTimeUnit
        );
        return newState;
    }
    
    else if (isEmotionOrThreeClassSentimentOrSourcesPieChart(chartId) && state[chartId].data.length > 0) {
        const pieChartMentionsToUpdate = [
            threeClassSentimentCategory + MENTIONS_LABEL, 
            emotionCategory,
            commentOrTweetAfterRelevanceUpdates.source
        ];
        let newState = updateEmotionSentimentOrSourcesPieCharts(
            state,
            chartId,
            relevance,
            pieChartMentionsToUpdate
        );
        return newState;
    }

    else if (FIVE_CLASS_SENTIMENT_PIE_CHARTS_IDS.includes(chartId) && state[chartId].data.length > 0) {
        const pieChartMentionsToUpdate = [
            sentimentCategory + MENTIONS_LABEL
        ];
        let newState = updateEmotionSentimentOrSourcesPieCharts(
            state,
            chartId,
            relevance,
            pieChartMentionsToUpdate
        );
        return newState;
    }
    
    else if (isEmotionOrSentimentBarChartWithData(chartId, state)){
        let newState = updateEmotionOrSentimentBarCharts(
            state,
            chartId,
            relevance,
            emotionCategory
        );
        return newState;
    }

    else if (isSubTopicClustersChartWithData(chartId, state)) {
        let newState = updateSubTopicClustersChart(
            state,
            chartId,
            relevance,
            commentOrTweetAfterRelevanceUpdates,
            emotionCategory
        );
        return newState;
    }
    return state;
}

export function getThreeClassSentimentCategory (sentimentCategory) {
    if (sentimentCategory === VERY_POSITIVE) {
        return POSITIVE;
    }
    else if (sentimentCategory === VERY_NEGATIVE) {
        return NEGATIVE;
    }
    return sentimentCategory;
}

export function isTrendOrPercentageTrendChart(chartId) {
    return (EMOTION_OR_SENTIMENT_TREND_CHART_IDS.includes(chartId) || EMOTION_OR_SENTIMENT_PERCENTAGE_TREND_CHART_IDS.includes(chartId));
}

export function isEmotionOrThreeClassSentimentOrSourcesPieChart(chartId) {
    return (EMOTION_OR_THREE_CLASS_SENTIMENT_PIE_CHARTS_IDS.includes(chartId) || AVAILABLE_SOURCES_PIE_CHART_IDS.includes(chartId));
}

export function updateEmotionOrSentimentMentionsCharts(
    state,
    chartId,
    relevance,
    emotionCategory,
    threeClassSentimentCategory) {
    let newState = JSON.parse(JSON.stringify(state));
    for (const element of newState[chartId]) {
        if (doesChartElementNeedToBeUpdated([emotionCategory, threeClassSentimentCategory, TOTAL], element.category)) {
            if (relevance) {
                element.count = parseInt(element.count, PARSE_INT_RADIX) + 1;
            }
            else {
                element.count = parseInt(element.count, PARSE_INT_RADIX) - 1;
            }
        }
    }
    return newState;
}

export function updateEmotionOrSentimentTrendCharts(
    state,
    commentOrTweetAfterToggling,
    chartId,
    relevance,
    emotionCategory,
    threeClassSentimentCategory,
    trendChartTimeUnit
    ) {
    let newState = JSON.parse(JSON.stringify(state));
    for (const categoryElement of newState[chartId]) {
        if (doesChartElementNeedToBeUpdated([emotionCategory, threeClassSentimentCategory, TOTAL], categoryElement.category.toLowerCase())) {
            categoryElement.data = updateCountFromCorrectDateInEmotionSentimentTrendChart(
                categoryElement.data,
                relevance,
                commentOrTweetAfterToggling,
                trendChartTimeUnit
            );
        }
    }
    return newState;
}

export function updateCountFromCorrectDateInEmotionSentimentTrendChart(
    categoryElementData,
    relevance, 
    commentOrTweetAfterToggling,
    trendChartTimeUnit
    ) {
    for (const dataElement of categoryElementData) {
        if (doesTrendChartElementMatchCommentDate(dataElement, commentOrTweetAfterToggling, trendChartTimeUnit)) {
            if (relevance) {
                dataElement[1] = parseInt(dataElement[1], PARSE_INT_RADIX) + 1;
            }
            else {
                dataElement[1] = parseInt(dataElement[1], PARSE_INT_RADIX) - 1;
            }
        }
    }
    return categoryElementData;
}

export function doesTrendChartElementMatchCommentDate(
    dataElement,
    commentOrTweetAfterToggling,
    trendChartTimeUnit
    ) {
    const commentOrTweetDateTime = moment(commentOrTweetAfterToggling.datetime);
    let yearOfCommentOrTweet     = commentOrTweetDateTime.format("YYYY");
    let monthOfCommentOrTweet    = commentOrTweetDateTime.format("M");
    let dayOfCommentOrTweet      = commentOrTweetDateTime.format("D");
    let hourOfCommentOrTweet     = commentOrTweetDateTime.format("H");
    
    let dayToAdjust  = getDayToAdjust(dayOfCommentOrTweet, trendChartTimeUnit);
    let hourToAdjust = getHourToAdjust(hourOfCommentOrTweet, trendChartTimeUnit);
    
    let dataElementYear = moment(dataElement[0]).format("YYYY");
    let dataElementMonth = moment(dataElement[0]).format("M");
    let dataElementDay = moment(dataElement[0]).format("D");
    let dataElementHour = moment(dataElement[0]).format("H");

    return (
        dataElementYear === yearOfCommentOrTweet && 
        dataElementMonth === monthOfCommentOrTweet && 
        dataElementDay === dayToAdjust &&
        dataElementHour === hourToAdjust
    );
}

export function getDayToAdjust(dayOfCommentOrTweet, trendChartTimeUnit) {
    if (trendChartTimeUnit === MONTH_UNIT) {
        return DEFAULT_DAY_FOR_MONTHLY_TREND_CHARTS;
    }
    return dayOfCommentOrTweet;
}

export function getHourToAdjust(hourOfCommentOrTweet, trendChartTimeUnit) {
    if (trendChartTimeUnit === HOUR_UNIT) {
        return hourOfCommentOrTweet;
    }
    return DEFAULT_HOUR_FOR_DAILY_AND_MONTHLY_TREND_CHARTS;
}

export function updateEmotionSentimentOrSourcesPieCharts(
    state,
    chartId,
    relevance,
    pieChartMentionsToUpdate
    ) {
    let newState = JSON.parse(JSON.stringify(state));
    for (const categoryElement of newState[chartId].data) {
        if (doesChartElementNeedToBeUpdated(pieChartMentionsToUpdate, categoryElement[0].toLowerCase())) {
            if (relevance) {
                categoryElement[1] = parseInt(categoryElement[1], PARSE_INT_RADIX) + 1;
                break;
            }
            else {
                categoryElement[1] = parseInt(categoryElement[1], PARSE_INT_RADIX) - 1;
                break;
            }  
        }
    }
    if (chartId === EMOTION_PIE_CHART_ID) {
        newState = updateEmotionPieChartTotalCount(
            newState,
            chartId,
            relevance,
            pieChartMentionsToUpdate
        );
    }
    else {
        newState = updateSentimentAndSourcesPieChartsAndSubTopicChartTotalCount(
            newState,
            chartId,
            relevance
        );
    }
    return newState;
}

export function updateEmotionPieChartTotalCount(
    newState,
    chartId,
    relevance,
    pieChartMentionsToUpdate
) {
    if (!pieChartMentionsToUpdate.includes(NO_SPECIFIC_EMOTION)) {
        if (relevance) {
            newState[chartId].count += 1;
        }
        else {
            newState[chartId].count -= 1;
        }  
    }
    return newState;
}

export function updateSentimentAndSourcesPieChartsAndSubTopicChartTotalCount(
    newState,
    chartId,
    relevance
) {
    if (relevance) {
        newState[chartId].count += 1;
    }
    else {
        newState[chartId].count -= 1;
    }  
    return newState;
}

export function isEmotionOrSentimentBarChartWithData(chartId, state) {
    return (EMOTION_OR_SENTIMENT_BAR_CHART_IDS.includes(chartId) && state[chartId].values.length > 0);
}

export function updateEmotionOrSentimentBarCharts (
    state,
    chartId,
    relevance,
    emotionCategory
    ) {
    let newState = JSON.parse(JSON.stringify(state));
    let i = 0;
    for (const categoryElement of newState[chartId].categories) {
        if (categoryElement.toLowerCase() === emotionCategory) {
            if (relevance) {
                newState[chartId].values[i] = parseInt(newState[chartId].values[i], PARSE_INT_RADIX) + 1;
            }
            else {
                newState[chartId].values[i] = parseInt(newState[chartId].values[i], PARSE_INT_RADIX) - 1;
            }   
        }
        i += 1;
    }
    return newState;
}

export function doesChartElementNeedToBeUpdated (
    categoriesThatNeedUpdating,
    chartElementCategory
) {
    return categoriesThatNeedUpdating.includes(chartElementCategory);
}

export function updateSubTopicClustersChart(
    state,
    chartId,
    relevance,
    commentOrTweetAfterRelevanceUpdates,
    emotionCategory
) {
    let commentOrTweetSubTopicId = commentOrTweetAfterRelevanceUpdates.subTopicId;
    if (commentOrTweetSubTopicId === null || commentOrTweetSubTopicId < 0) {
        return state;
    }

    let newState = JSON.parse(JSON.stringify(state));
    for (let subTopic of newState[chartId].subTopics) {
        if (subTopic.id !== commentOrTweetSubTopicId) {
            continue;
        }
        if (relevance) {
            subTopic.subTopicTotalCommentCount             += 1;
            subTopic.emotionCommentCounts[emotionCategory] += 1;
        }
        else {
            subTopic.subTopicTotalCommentCount             -= 1;
            subTopic.emotionCommentCounts[emotionCategory] -= 1;
        }
    }
    newState = updateSentimentAndSourcesPieChartsAndSubTopicChartTotalCount(
        newState,
        chartId,
        relevance
    );
    return newState;
}


// WEBPACK FOOTER //
// ./src/features/shared-components/chart/redux/updateChartForRelevanceUpdatesOfCommentOrTweetService.js